<template>
  <div class="timer-interlayer">
    <!-- <img v-if="image" :src="image" /> -->
    <div class="bg" :style="{backgroundImage: 'url('+image+')'}"></div>
    <div class="countdown" v-if="countDown">
      <span v-if="countDown.d" class="number">{{ countDown.d }}</span>
      <span v-if="countDown.d"> 天 </span>
      <span class="number">{{ countDown.h }}</span> :
      <span class="number">{{ countDown.m }}</span> :
      <span class="number">{{ countDown.s }}</span>
    </div>
    <div class="more" v-if="showMore" @click="goto(url)">更多</div>
  </div>
</template>
<script>
export default {
  name: "TimerInterlayer",
  data() {
    return {
      countDown: null,
      hander: {
        timer: null,
        interval: null
      }
    };
  },
  created() {
    let now = (new Date()).valueOf();
    if (now < this.start) {
      this.startDelayCountdown(this.start - now);
    } else if (now < this.end) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    if (this.hander.timer) {
      clearTimeout(this.hander.timer);
    }
    if (this.hander.interval) {
      clearInterval(this.hander.interval);
    }
  },
  methods: {
    startDelayCountdown: function(delay) {
      this.hander.timer = setTimeout(() => {
        this.startCountdown();
      }, delay);
    },
    updateCountdown: function() {
      let now = (new Date()).valueOf();
      let left = this.end - now;
      if (left < 0) {
        this.countDown = null;
        clearInterval(this.hander.interval);
        return;
      }
      let s = parseInt(left / 1000) % 60;
      let m = parseInt(left / (1000 * 60)) % 60;
      let h = parseInt(left / (1000 * 60 * 60)) % 24;
      let d = parseInt(left / (1000 * 60 * 60 * 24));
      this.countDown = {
        d: d && this.formatTime(d),
        h: this.formatTime(h),
        m: this.formatTime(m),
        s: this.formatTime(s)
      };
    },
    formatTime: function(number) {
      return "" + (number < 10 ? "0" + (number || "0") : number);
    },
    startCountdown: function() {
      this.updateCountdown();
      this.hander.interval = setInterval(() => {
        this.updateCountdown();
      }, 1000);
    },
    showCountdown: function() {
      if (this.type != 2) {
        return false;
      }
      let now = new Date().getTime();
      return now > this.start;
    }
  },
  props: {
    image: {
      type: String
    },
    showMore: {
      type: Boolean,
      default: false
    },
    url: {
      type: String
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number
    }
  }
};
</script>

<style lang="less" scoped>
.timer-interlayer {
  width: 100%;
  height: 9vw;
  position: relative;
  .bg {
    height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
  }
  .countdown {
    position: absolute;
    width: 100%;
    height: 100%;
    color: #f04f4f;
    font-size: 12px;
    font-weight: 500;
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .number {
      padding: 2px 4px;
      color: white;
      background-color: #f04f4f;
      border-radius: 3px;
      margin: 0 3px;
    }
  }
  .more {
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #666666;
    right: 0;
    height: 100%;
    top: 0;
    align-items: center;
    font-size: 14px;
    padding-right: 2px;
    &::after {
      content: "";
      width: 8px;
      height: 8px;
      border-top: #666666 1px solid;
      border-right: #666666 1px solid;
      transform: rotate(45deg);
    }
  }
}
</style>